import React from "react";
import styled from "styled-components";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { useDashboardContext } from "./DashboardProvider.jsx";
import { DashboardHeader, OpsFounderReportShell } from "./components";
import LeadPulseWidget from "./components/LeadPulseWidget.jsx";

const DashboardContainer = styled.div`
  padding: 0; /* Padding handled by MobileWrapper in Layout */
  background: #f5f5f5;
  min-height: 100vh;
  min-width: 0; /* Prevent squishing */
`;

const DashboardPage = () => {
  const { permissions = [] } = useAuth();
  const { refreshing, refreshDashboard, lastRefreshed } = useDashboardContext();
  const canView = hasAnyPermission(permissions, ["reports:dashboard"]);

  return (
    <DashboardContainer>
      <DashboardHeader
        refreshing={refreshing}
        refreshDashboard={refreshDashboard}
        lastRefreshed={lastRefreshed}
      />

      {canView ? <LeadPulseWidget /> : null}

      <OpsFounderReportShell canView={canView} />
    </DashboardContainer>
  );
};

export default DashboardPage;

function hasAnyPermission(permissions, requiredPermissions) {
  return requiredPermissions.some((permission) => permissions.includes(permission));
}
